// extracted by mini-css-extract-plugin
export default {"topNavBox_right":"TopNavRightBox_topNavBox_right__b8AGM","wrapper":"TopNavRightBox_wrapper__RRYXA"};